import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row align-middle mt-3"
};
const _hoisted_2 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_3 = { class: "row align-middle mt-2" };
const _hoisted_4 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-sm-star" };
const _hoisted_5 = { class: "list-inline list-pipe text-nowrap" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "col-sm-5 col-12 text-end pl-0" };
const _hoisted_9 = {
    key: 2,
    class: "row align-middle mt-3"
};
const _hoisted_10 = { class: "col-12 text-start pl-0 mb-3" };
const _hoisted_11 = { class: "col-12 text-end pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$t('homePage.Titel')
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$appHost.config.loginMethods, (method) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (method.beginGroup)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", { class: "col-12 text-end pl-0" }, [
                                    _createElementVNode("div", { class: "separator separator-dashed" })
                                ], -1)
                            ]))]))
                        : _createCommentVNode("", true),
                    (method.name === 'user')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("form", null, [
                                _createVNode(_component_g_text_field, {
                                    dataObject: _ctx.$data,
                                    dataMember: "userName",
                                    label: _ctx.$t('account.UserNameEMail') + '*',
                                    mode: "email",
                                    "data-mode": "model",
                                    "show-clear-button": false,
                                    onEnterKey: _ctx.runLogin
                                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                                _createVNode(_component_g_text_field, {
                                    dataObject: _ctx.$data,
                                    dataMember: "password",
                                    label: _ctx.$t('account.Password') + '*',
                                    mode: "password",
                                    "data-mode": "model",
                                    onEnterKey: _ctx.runLogin,
                                    autocomplete: "on"
                                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                                (_ctx.hasError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("ul", _hoisted_5, [
                                        (method.allowPasswordReset ?? true)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                                _createVNode(_component_router_link, {
                                                    to: "/login/recovery",
                                                    tabindex: "-1"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('account.ForgotPassword')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        (method.allowRegister ?? true)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                                                _createVNode(_component_router_link, {
                                                    to: "/login/register",
                                                    tabindex: "-1"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('account.Register')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_g_button, {
                                        text: _ctx.$t('account.Login'),
                                        "is-loading": _ctx.isLoading,
                                        disabled: _ctx.disableLogin,
                                        onClick: _ctx.runLogin
                                    }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                                ])
                            ])
                        ], 64))
                        : (method.name === 'azureadconnect')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('client.Identity.AzureAdConnect.Notes')), 1),
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_g_button, {
                                        text: _ctx.$t('client.Identity.AzureAdConnect.LoginButton'),
                                        class: "w-100",
                                        onClick: _ctx.runOIDC
                                    }, null, 8, ["text", "onClick"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                ], 64));
            }), 256))
        ]),
        _: 1
    }, 8, ["title"]));
}
